import React from 'react'
import styles from './UIGamePlayerInfoHeaderPointsPrivate.module.scss'

export interface UIGamePlayerInfoHeaderPointsPrivateProps {
    points: number
    color: string
}

export const UIGamePlayerInfoHeaderPointsPrivate = ({
    points,
    color,
}: UIGamePlayerInfoHeaderPointsPrivateProps) => (
    <div className={styles.container} style={{'--color': color} as React.CSSProperties}>
        <div className={styles.points}>
            {points}
        </div>
    </div>
)
